module.exports = __webpack_public_path__ + "img/surgelazione.9ee594bb.jpg";